<div *ngIf="model" class="emoji-container">
  <u-emoji class="emoji" *ngIf="unicode && !model.image" [unicode]="unicode" [spriteEmojiSize]="18"></u-emoji>
  <u-icon class="image" *ngIf="model.image" [model]="{ type: 'img', value: { lightUrl: model.image } }"></u-icon>
</div>
